/**
 * Vuex 根入口文件
 * 注册所有 Vuex 模块，创建并导出 Vuex.Store 实例
 */

import Vue from 'vue'
import Vuex from 'vuex'

// 导入用户信息模块
import globalUserInfo from './globalUserInfo'
// 导入 tabs 模块
import tabs from './tabs'
// 导入 serial 模块
import serial from './serial'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    globalUserInfo,
    tabs,
    serial
  }
})
